<div class="container">
  <h2>App reports</h2>

  <div class="controls">
    <div style="display:flex; flex-direction:column;align-items: flex-start;min-width: 150px;">
      <label class="control-label" for="filterType">Type of user:</label>
      <select id="filterType" class="form-control" [(ngModel)]="filterType" (change)="onFilterTypeChange()">
        <option>Both</option>
        <option>Agent</option>
        <option>Client</option>
      </select>
    </div>

    <div style="display:flex; flex-direction:column;align-items: flex-start;">
      <label class="control-label" for="searchName">Name</label>
      <div class="input-group">
        <input id="searchName" class="form-control" placeholder="Search name" [(ngModel)]="searchTerm" />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button" (click)="clearSearchInput()">X</button>
        </div>
      </div>
    </div>

    <div style="display:flex; flex-direction:column;align-items: flex-start;min-width:150px;margin-left:10px;">
      <label class="control-label" for="supervisorFilter">Supervisor</label>
      <select id="supervisorFilter" class="form-control" [(ngModel)]="supervisorFilter" [disabled]="filterType !== 'Agent'">
        <option *ngFor="let s of supervisors" [value]="s">{{s}}</option>
      </select>
    </div>

  </div> 

  <div style="display:flex; flex-direction:row; justify-content:flex-end; gap:20px; margin-top:10px;">
    <button class="btn btn-primary" (click)="onSearch()">Search</button>
    <button class="btn btn-warning"  (click)="onClear()">Reset</button>
    <button class="btn btn-success" (click)="exportToExcel()">Export</button>
  </div>


  <div *ngIf="loading" class="text-center"><div class="spinner-border" role="status"></div></div>
  <div *ngIf="error" class="alert alert-danger">{{error}}</div>

  <table class="viewDataTable" *ngIf="!loading && !error">
    <thead>
      <tr>
        <th class="viewDataTableHeading">Name</th>
        <th class="viewDataTableHeading">Type</th>
        <th class="viewDataTableHeading">Login Count</th>
        <th class="viewDataTableHeading">Last Login</th>
        <th class="viewDataTableHeading">Supervisor</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="rows.length === 0">
        <td class="viewDataTableCell text-muted" colspan="5">No results found.</td>
      </tr>
      <tr *ngFor="let r of rows">
        <td class="viewDataTableCell">{{r.displayName}}</td>
        <td class="viewDataTableCell">{{r.userType}}</td>
        <td class="viewDataTableCell">{{r.loginCount}}</td>
          <td class="viewDataTableCell">{{r.lastLoginFormatted}}</td>
          <td class="viewDataTableCell">{{r.supervisorName}}</td>
      </tr>
    </tbody>
  </table>
</div>
